export const APP_IMAGE_BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1920
};
export const APP_GRID_BREAKPOINTS = {
  sm: 656,
  md: 1096,
  lg: 1352,
  xl: 1544
};
